export default __webpack_public_path__ + "static/media/building.65edce17.png";